import { FormSection } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import Row from './Row';
import HoursMinsSelect from './HoursMinsSelect';
import {
  customRemindHours,
  getSecondReminderCustomHours,
  getSecondReminderMaxHours,
  maxHours,
} from '../customerReminderUtils';

const CustomerReminder = ({ name, barberReminderTime, reminderTime, minInterval, commonHiddenFields }) => (
  <FormSection name={name}>
    <Row label={t('admin:shops.add.first_client_reminder')} action="barber_reminder" hide={['phone', ...(commonHiddenFields || [])]} />
    <HoursMinsSelect
      name="barber_reminder.time"
      current={barberReminderTime}
      max={{ hours: maxHours, minutes: 5 }}
      customHours={customRemindHours}
      minInterval={minInterval}
      data-automation-id="first-client-reminder-time"
    />
    <Row label={t('admin:shops.add.second_client_reminder')} action="reminder" hide={commonHiddenFields} />
    <HoursMinsSelect
      name="reminder.time"
      current={reminderTime}
      max={getSecondReminderMaxHours(barberReminderTime || { hours: 0, minutes: 0 })}
      customHours={getSecondReminderCustomHours(barberReminderTime || { hours: 0, minutes: 0 })}
      minInterval={minInterval}
      data-automation-id="second-client-reminder-time"
    />
  </FormSection>
);

CustomerReminder.propTypes = {
  name: PropTypes.string.isRequired,
  barberReminderTime: PropTypes.shape({
    hours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  reminderTime: PropTypes.shape({
    hours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  minInterval: PropTypes.number,
  commonHiddenFields: PropTypes.arrayOf(PropTypes.string),
};

CustomerReminder.defaultProps = {
  minInterval: null,
  commonHiddenFields: [],
  barberReminderTime: null,
  reminderTime: null,
};

export default CustomerReminder;
